import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";


import PermisosListSelect from "../Permisos/PermisosListSelect.js"

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"


import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

class Perfil extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,
            permisos_checked: [],
            permisos_disabled: [],

            last_name: "",
            first_name: "",
            username: "",
            email: "",
            password: "",
            password2: "",
            grupos: [],
            errors: {},
            postVariables: ['last_name', 'first_name', 'password'],
        };
    }

    static propTypes = {
        onOpen: PropTypes.func,
        onClose: PropTypes.func,
    }

    resetForm() {
        this.setState({
            activeTab: 1,
            permisos_checked: [],
            permisos_disabled: [],
            errors: {},

            last_name: "",
            first_name: "",
            username: "",
            email: "",
            password: "",
            password2: "",
            grupos: [],
        });
    }

    validate() {
        const { password, password2 } = this.state;
        if (password != password2) {
            this.setState(prevState => {
                prevState.errors['password2'] = [{
                    code: "invalid",
                    detail: "Las contraseñas deben ser iguales"
                }];
                return prevState;
            })
            return false;
        }
        return true;
    }

    getData() {
        const { action } = this.props;
        const { grupos, postVariables, permisos_checked, permisos_disabled } = this.state;
        let data = {};
        postVariables.forEach(x => {
            if (x != 'password' || this.state[x].length > 0)
                data[x] = this.state[x];
        });
        data['grupos'] = grupos;
        let permisos = permisos_checked.map(x => parseInt(x)).filter(x => permisos_disabled.filter(y => y === x).length == 0);
        data['permisos'] = permisos;
        return data;
    }

    setData(data) {
        this.setState({
            permisos_checked: (data.permisos ? data.permisos : []),
            permisos_disabled: (data.perfil.grupos ? this.parseGrupos(data.perfil.grupos) : []),

            last_name: data.last_name,
            first_name: data.first_name,
            username: data.username,
            email: data.email,
            grupos: (data.grupos ? data.grupos : []),
        });
    }


    parseGrupos(grupos) {
        let permisos = grupos.map(x => x.permisos);
        if (permisos.length > 0)
            permisos = permisos.reduce(
                (result, next) => result.concat(
                    next.filter(nextEl =>
                        result.filter(resultEl => resultEl == nextEl).length == 0)
                )
            );
        return permisos.map(x => x.id);
    }

    onGroupChange(value) {
        let errors = this.state.errors;
        if (errors) errors.grupos = null;
        if (value) {
            this.setState({
                grupos: value.map(x => x.id),
                permisos_disabled: this.parseGrupos(value),
                permisos_checked: [],
                errors: errors
            });
        } else {
            this.setState({
                grupos: [],
                permisos_disabled: [],
                permisos_checked: [],
                errors: errors
            });
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    render() {
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];
        return (
            <ParadigmaModal
                navButton={true}
                nav={({
                    name: 'Perfil',
                    icon: 'fa fa-user',
                    tag: 'button',
                    className: 'dropdown-item'
                })}

                getUrl={api.usuarios.perfil}
                submitUrl={api.usuarios.perfil}
                submitType={"PATCH"}

                onOpen={() => (this.props.onOpen ? this.props.onOpen() : null)}
                onGotData={(data) => this.setData(data)}
                onClose={() => { (this.props.onClose ? this.props.onClose() : null); this.resetForm(); }}
                onValidation={() => this.validate()}
                onGotErrors={(errors) => this.setErrors(errors)}
                onCleanForm={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={"Editar Perfil"}

                successMessage={"El Usuario ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}

                saveButton={true}
                closeButton={true}
                className="ui-paradigma-modal ui-paradigma-modal-wide ui-modal-with-tabs"
            >
                <Nav tabs className="ui-modal-tabs">
                    <NavItem>
                        <NavLink
                            className={(this.state.activeTab == 1 ? "active" : "")}
                            onClick={() => { this.setState({ activeTab: 1 }) }}
                        >Usuario</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={(this.state.activeTab == 2 ? "active" : "")}
                            onClick={() => { this.setState({ activeTab: 2 }) }}
                        >Permisos</NavLink>
                    </NavItem>
                </Nav>
                <TabContent
                    activeTab={this.state.activeTab}
                    className="ui-modal-tab-content">
                    <TabPane tabId={1}>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Datos del usuario</p>
                            <div className="ui-form-grid">
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Apellido"}
                                    value={this.state.last_name}
                                    onChange={(e) => {
                                        let errors = this.state.errors;
                                        if (errors) errors.last_name = null;
                                        this.setState({ last_name: e.target.value, errors: errors });
                                    }}
                                    error={(this.state.errors ? this.state.errors.last_name : null)}
                                />
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Nombre"}
                                    value={this.state.first_name}
                                    onChange={(e) => {
                                        let errors = this.state.errors;
                                        if (errors) errors.first_name = null;
                                        this.setState({ first_name: e.target.value, errors: errors });
                                    }}
                                    error={(this.state.errors ? this.state.errors.first_name : null)}
                                />
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Usuario"}
                                    disabled={true}
                                    value={this.state.username}
                                    onChange={(e) => {
                                        let errors = this.state.errors;
                                        if (errors) errors.username = null;
                                        this.setState({ username: e.target.value, errors: errors });
                                    }}
                                    error={(this.state.errors ? this.state.errors.username : null)}
                                />
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Email"}
                                    disabled={true}
                                    value={this.state.email}
                                    onChange={(e) => {
                                        let errors = this.state.errors;
                                        if (errors) errors.email = null;
                                        this.setState({ email: e.target.value, errors: errors });
                                    }}
                                    error={(this.state.errors ? this.state.errors.email : null)}
                                />
                            </div>
                        </section>

                        <section className="ui-modal-section">
                            <p className="ui-section-label">Seguridad</p>
                            <div className="ui-form-grid">
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Contraseña"}
                                    type={"password"}
                                    value={this.state.password}
                                    onChange={(e) => {
                                        let errors = this.state.errors;
                                        if (errors) errors.password = null;
                                        this.setState({ password: e.target.value, errors: errors });
                                    }}
                                    error={(this.state.errors ? this.state.errors.password : null)}
                                />
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Repetir Contraseña"}
                                    type={"password"}
                                    value={this.state.password2}
                                    onChange={(e) => {
                                        let errors = this.state.errors;
                                        if (errors) errors.password2 = null;
                                        this.setState({ password2: e.target.value, errors: errors });
                                    }}
                                    error={(this.state.errors ? this.state.errors.password2 : null)}
                                />
                            </div>
                        </section>
                    </TabPane>
                    <TabPane tabId={2}>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Grupos</p>
                            <div className="ui-form-grid">
                                <div className="ui-span-2">
                                    <ParadigmaLabeledInput
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        label={"Grupos"}
                                        inputComponent={
                                            <ParadigmaAsyncSeeker
                                                disabled={true}
                                                multiselect={true}
                                                onChange={(value) => this.onGroupChange(value)}
                                                url={api.usuarios.grupos + "?fields=id,nombre,permisos"}
                                                value={this.state.grupos}
                                            />
                                        }
                                        error={(this.state.errors ? this.state.errors.grupos : null)}
                                    />
                                </div>
                            </div>
                        </section>

                        <section className="ui-modal-section">
                            <p className="ui-section-label">Permisos</p>
                            <div className="ui-permissions-panel">
                                <PermisosListSelect
                                    disabled={true}
                                    disabledNodes={this.state.permisos_disabled}
                                    onChange={(value) => this.setState({ permisos_checked: value })}
                                    checked={this.state.permisos_checked}
                                    fieldName={"permisos"}
                                />
                            </div>
                        </section>
                    </TabPane>
                </TabContent>
            </ParadigmaModal>
        );
    }
}

export default Perfil;




// WEBPACK FOOTER //
// ./src/views/Usuarios/Usuarios/Perfil.js